
import { defineAsyncComponent, defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';
import AnswerButton from '@/components/App/AnswerButton/index.vue';

import MessageWrap from '@/components/MessageWrap/index.vue';

export default defineComponent({
	name: 'links',

	components: {
		MessageWrap,
		AnswerButton,

		refs_share: defineAsyncComponent(() => import('./RefsShare/index.vue'))
	},

	props: {
		message: {
			type: Object as PropType<Message>
		},

		isShowMessageTail: {
			type: Boolean
		},

		isLastMessage: {
			type: Boolean
		},
		avatar: {
			type: String
		},
		respondentId: {
			type: Number,
			required: true
		}
	},

	emits: ['send-message', 'init'],

	computed: {
		questionType(): string {
			return this.message?.question_type ?? 'refs_share';
		}
	}
});
